import { ModuleConfig, GetRouteGroupFunc, RouteGroup } from 'framework/components/navigation/Navigation.interfaces';

// resolve menus page-groups, including dynamic groups with async call
export const resolvePageGroups = async (module: ModuleConfig): Promise<ModuleConfig> => {
  const fetchable = module.pageGroups && typeof module.pageGroups === 'function';

  const getRouteGroup = fetchable
    ? (module.pageGroups as GetRouteGroupFunc)
    : async () => (module.pageGroups as RouteGroup[]) ?? [];

  const pageGroups = await getRouteGroup();

  return {
    ...module,
    pageGroups,
  };
};
